import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Logout = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10 3.35498V7.62609" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M6.66667 5.09106C4.84889 6.21106 3.63722 8.2194 3.63722 10.5116C3.63722 14.0261 6.48611 16.8744 10 16.8744C13.5139 16.8744 16.3628 14.0255 16.3628 10.5116C16.3628 8.21995 15.1506 6.21162 13.3333 5.09106" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Logout;